import { memo } from 'react';
import cx from 'classnames';

import { Spinner } from 'components/Icon';

import styles from './Loader.module.scss';

export type LoaderProps = {
  global?: boolean;
};

const Loader = ({ global = false }: LoaderProps) => (
  <div
    className={cx(styles.overlay, {
      [styles.global]: global,
      [styles.local]: !global
    })}
  >
    <Spinner />
  </div>
);

const memoizedLoader = memo(Loader);

export default memoizedLoader;
